import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { EmptyEmployee, Form, IEmptyEmployee } from "./Form";
import { IModal } from "./Employee";
import { Filter, IEmptyFilter } from "./Filter";
import { ILogin, IPermissionProps } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    toast: any,
    setModal: (modal: IModal) => void,
    reload: boolean,
    permissions: IPermissionProps,
}

export const EmptyFilter = {
    employee_Name: "",
    email: "",
    branch_ID: null,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IEmptyEmployee[], loading: boolean });
    const [filter,setFilter]=useState<IEmptyFilter>(EmptyFilter);

    const dt = useRef<any>(null);
    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loaddata = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("tbl_Employee", "GET", null, `filter=${JSON.stringify(filter)}`, props.toast);
        if(response){
            const data: IEmptyEmployee[] = await response?.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Employee Details</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyEmployee });
    };

    const openEdit = (rowData: IEmptyEmployee) => {
        props.setModal({ open: true, singleData: rowData });
    }

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>: ''
        );
    };
    const rightToolbarTemplate = () => {
        return (
            <>
                <React.Fragment>
                    {/* <Button label="SendMail" icon="pi pi-envelope" className="p-button-info mr-2" /> */}
                </React.Fragment>
            </>
        );
    };

    const actionBodyTemplate = (rowData: IEmptyEmployee) => {
        // onClick={() => openEdit(rowData)}
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    // useEffect(() => {
    //     loaddata();
    // }, [filter]);
    useEffect(() => {
        loaddata();
    }, [filter, props.reload]);

    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filter={filter} setFilter={(filter: IEmptyFilter) => setFilter(filter)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                size="small"
                resizableColumns showGridlines columnResizeMode="expand" scrollable scrollHeight="70vh"
                ref={dt}
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="Sr N" style={{minWidth: '80px'}} body={(data, options) => options.rowIndex + 1} />
                <Column field="emp_Code" header="Emp_Code" style={{ minWidth: '6rem' }} />
                <Column field="first_Name" header="Emp First Name" style={{ minWidth: '9rem' }} />
                <Column field="last_Name" header="Last Name" style={{ minWidth: '9rem' }} />
                <Column field="teamLead_Name" header="Team Lead" style={{ minWidth: '12rem' }} />
                <Column field="mob" header="Mobile" style={{ minWidth: '13rem' }} />
                <Column field="email" header="Email" style={{ minWidth: '18rem' }} />
                <Column field="hangout" header="Hangout" style={{ minWidth: '18rem' }} />
                <Column field="branch_Name" header="Branch" style={{ minWidth: '5rem' }} />
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="adhar" header="Adhar" style={{ minWidth: '9rem' }} />}
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="pan" header="Pan Card" style={{ minWidth: '8rem' }} />}
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="dateofJoining" header="Date of Joining" style={{ minWidth: '8rem' }} />}
                {/* {(_roles.includes(1) || _roles.includes(26)) &&  <Column field="dateofJoining" header="Date of Joining" style={{ minWidth: '100px' }} sortable body={(rowData: any) => <span>{(rowData?.dateofJoining !== undefined && rowData?.dateofJoining !== null && rowData?.dateofJoining?.trim() !== "") ? safeFormatDate(new Date(rowData?.dateofJoining?.split("/")[2], rowData?.dateofJoining?.split("/")[1], rowData?.dateofJoining?.split("/")[0]).toDateString(), "dd/MM/yyyy", DateFormat) : ""}</span>} />} */}
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="endDate" header="End Date" style={{ minWidth: '7rem' }} />}
                {/* {(_roles.includes(1) || _roles.includes(26)) && <Column field="endDate" header="Date of Joining" style={{ minWidth: '100px' }} sortable body={(rowData: any) => <span>{safeFormatDate(new Date(rowData?.endDate?.split(" ")[0].split("-")[2], rowData?.endDate?.split(" ")[0].split("-")[1], rowData?.endDate?.split(" ")[0].split("-")[0]).toDateString(), "dd/MM/yyyy", DateFormat)} {rowData?.endDate?.split(" ")[1]} </span>} />} */}
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="salary" header="Salary" style={{ minWidth: '8rem' }} />}
                {(_roles.includes(1) || _roles.includes(26)) && <Column field="department_Name" header="Department" style={{ minWidth: '14rem' }} />}
                {props.permissions.is_Update && <Column header="Action" body={actionBodyTemplate} style={{ minWidth: '3rem' }}/>}
            </DataTable>
        </>
    );
}